import Stack from "@mui/material/Stack";
import { theme } from "@polifonia/theme";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/Button";
import { Modal } from "@/components/Modal";
import { Typography } from "@/components/Typography";

interface DisconnectMetaAdsModalProps {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DisconnectMetaAdsModal: React.FC<DisconnectMetaAdsModalProps> =
  function DisconnectMetaAdsModal({ open, isLoading, onClose, onConfirm }) {
    const { t } = useTranslation();

    return (
      <Modal
        open={open}
        handleClose={onClose}
        title={t("applications.metaAds.disconnectModal.title")}
        footer={
          <Stack direction="row" justifyContent="flex-end" gap="12px">
            <Button variant="secondary" onClick={onClose} disabled={isLoading}>
              {t("common.cancel")}
            </Button>
            <Button variant="danger" onClick={onConfirm} loading={isLoading}>
              {t("applications.metaAds.disconnectModal.confirm")}
            </Button>
          </Stack>
        }
      >
        <Stack gap="16px">
          <Typography variant="body" color={theme.colors.staticFgBody}>
            {t("applications.metaAds.disconnectModal.description")}
          </Typography>
        </Stack>
      </Modal>
    );
  };
